export default __webpack_public_path__ + "static/media/slash.27159958.svg";